import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../../shared/shared.module';
import { OperationGenericCommentPage } from './operation-generic-comment';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    OperationGenericCommentPage
  ],
  imports: [
    IonicPageModule.forChild(OperationGenericCommentPage),
    SharedModule,
    TextMaskModule,
    DirectivesModule,
  ],
  exports: [
    OperationGenericCommentPage
  ]
})
export class OperationGenericCommentPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-generic-comment/operation-generic-comment.module.ts